import { createContext, FC, ReactNode, useState } from 'react';
import FileIconCell from 'src/components/custom-cells/FileIconCell';
import { GridColumn } from 'src/components/GridWrapper';
import CompanyNameCell from 'src/sections/scan_manager/CompanyNameCell';
import RenameFile from 'src/sections/scan_manager/RenameFile';
import UploadedByCell from 'src/sections/scan_manager/UploadedByCell';
import UploadedOnCell from 'src/sections/scan_manager/UploadedOnCell';
import { SetState } from 'src/types/generic';

export const FileIcon = () => <span className="k-icon k-i-file k-i-file-vertical" />;

interface IRename {
  latestClickedId: number;
  setLatestClickedId: SetState<number>;
}
export const RenameContext = createContext<IRename>({} as IRename);
interface RenameProps {
  children: ReactNode;
}
export const RenameContextProvider: FC<RenameProps> = ({ children }) => {
  const [latestClickedId, setLatestClickedId] = useState(0);
  return (
    <RenameContext.Provider value={{ latestClickedId, setLatestClickedId }}>
      {children}
    </RenameContext.Provider>
  );
};

export const ScanManagerColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    width: '30px',
  },
  {
    field: 'file',
    title: '',
    component: FileIconCell,
    headerCell: FileIcon,
    width: '50px',
    menu: false,
  },
  {
    field: 'originalFile',
    title: 'File Name',
    filter: 'text',
    dataType: 'string',
    component: RenameFile,
  },
  {
    field: 'createdBy',
    title: 'Uploaded By',
    filter: 'text',
    dataType: 'string',
    editable: false,
    component: UploadedByCell,
  },
  {
    field: 'creationDate',
    title: 'Uploaded On',
    filter: 'date',
    dataType: 'date',
    editable: false,
    component: UploadedOnCell,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    dataType: 'string',
    editable: false,
    component: CompanyNameCell,
  },
];

export default ScanManagerColumns;
